import {authApi} from "./api";
import {FreezeUI} from "./freeze-ui";
import {Notifications} from "./notifications";

export class Profiles {
    static init() {
        document.querySelectorAll("[data-switch-profile]").forEach((el) => {
            el.addEventListener("click", async (e) => {
                e.preventDefault();

                const memberId = el.dataset.memberId;
                const memberName = el.dataset.memberName;

                FreezeUI.Freeze();

                try {
                    await authApi.put('/api/me/switch', {memberId: memberId});

                    Notifications.setNotificationCookie(`You are now logged in as ${memberName}`);

                    location.reload();
                } catch (err) {
                    console.error(err);
                    FreezeUI.UnFreeze();
                    Notifications.showError({ message: "We were unable to switch your profile." })
                }

            });
        });
    }
}
